
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_55fkh_1sqwf_142",
  "button": "awsui_button_55fkh_1sqwf_145",
  "action-button": "awsui_action-button_55fkh_1sqwf_150",
  "textarea": "awsui_textarea_55fkh_1sqwf_172",
  "textarea-readonly": "awsui_textarea-readonly_55fkh_1sqwf_225",
  "textarea-invalid": "awsui_textarea-invalid_55fkh_1sqwf_267",
  "textarea-warning": "awsui_textarea-warning_55fkh_1sqwf_276",
  "textarea-with-button": "awsui_textarea-with-button_55fkh_1sqwf_285"
};
  